import { render } from "./DashboardCollections.vue?vue&type=template&id=680d5154"
import script from "./DashboardCollections.vue?vue&type=script&lang=js"
export * from "./DashboardCollections.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/donorsweb/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__